import { Popover as AntPopover, type PopoverProps, type TooltipRef } from 'antd'
import { forwardRef } from 'react'

export type UiPopoverProps = PopoverProps

export const UiPopover = forwardRef<TooltipRef, UiPopoverProps>((props, ref) => (
  <AntPopover ref={ref} {...props} />
))

UiPopover.displayName = 'UiPopover'

export default UiPopover
